import { render } from "./biaoge.vue?vue&type=template&id=4b8c94e2&scoped=true"
import script from "./biaoge.vue?vue&type=script&lang=ts"
export * from "./biaoge.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4b8c94e2"

export default script